import { useQuery } from "@tanstack/react-query";
import { TestimonialsSection as TestimonialsUI } from "@/components/ui/testimonials-with-marquee";
import { fetchActiveTestimonials } from "@/services/testimonialsService";

export function TestimonialsSection() {
  const { data: testimonials = [], isLoading, error } = useQuery({
    queryKey: ["active-testimonials"],
    queryFn: fetchActiveTestimonials,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
    retry: 3,
  });

  // Se estiver carregando ou houver erro, não renderiza nada
  if (isLoading || error || testimonials.length === 0) {
    return null;
  }

  // Transformar os dados para o formato esperado pelo componente UI
  const formattedTestimonials = testimonials.map(testimonial => ({
    author: {
      name: testimonial.name,
      handle: testimonial.handle,
      avatar: testimonial.avatar_url
    },
    text: testimonial.text,
    href: testimonial.href
  }));

  return (
    <TestimonialsUI
      title="Depoimentos dos Nossos Jogadores"
      description="Veja o que nossos jogadores têm a dizer sobre suas experiências com nossos mentores"
      testimonials={formattedTestimonials}
    />
  );
} 